import React, { forwardRef } from 'react';

const RemoteAudio = forwardRef((props, ref) => {
  return <audio ref={ref} autoPlay />;
});

RemoteAudio.displayName = 'RemoteAudio';

export default RemoteAudio;
